import products from "../../api/products";

const state = () => ({
  linkedProduct: [],

  isFetchLinkedProductLoading: false,
  isFetchLinkedProductError: false,
  isFetchLinkedProductErrorResponse: null,

  isCreateLinkedProductLoading: false,
  isCreateLinkedProductError: false,
  isCreateLinkedProductErrorResponse: false,
});

const mutations = {
  FETCH_LINKED_PRODUCT_BEGIN(state) {
    state.isFetchLinkedProductLoading = true;
    state.isFetchLinkedProductError = false;
    state.isFetchLinkedProductErrorResponse = null;
  },
  FETCH_LINKED_PRODUCT_SUCCESSFUL(state, payload) {
    state.linkedProduct = payload;
    state.isFetchLinkedProductLoading = false;
  },
  FETCH_LINKED_PRODUCT_ERROR(state, err) {
    state.isFetchLinkedProductLoading = false;
    state.isFetchLinkedProductError = true;
    state.isFetchLinkedProductErrorResponse = err;
  },

  CREATE_LINKED_PRODUCT_BEGIN(state) {
    state.isCreateLinkedProductLoading = true;
    state.isCreateLinkedProductError = false;
    state.isCreateLinkedProductErrorResponse = null;
  },
  CREATE_LINKED_PRODUCT_SUCCESSFUL(state, payload) {
    state.linkedProduct.push(payload);
    state.isCreateLinkedProductLoading = false;
  },
  CREATE_LINKED_PRODUCT_ERROR(state, err) {
    state.isCreateLinkedProductLoading = false;
    state.isCreateLinkedProductError = true;
    state.isCreateLinkedProductErrorResponse = err;
  },
};

const actions = {
  async fetchLinkedProduct({ commit, dispatch }, lead_id) {
    commit('FETCH_LINKED_PRODUCT_BEGIN');
    try {
      
      const response = await products.loadLinkedProduct(lead_id);
      commit('FETCH_LINKED_PRODUCT_SUCCESSFUL', response.data);
    } catch(err) {
      dispatch("alerts/setAlert", { type: "error", message: err.response.data.message }, { root: true });
      commit('FETCH_LINKED_PRODUCT_ERROR', err.response.data);
    }
  },

  async createLinkedProduct({ commit, dispatch }, { lead_id, payload }) {
    commit("CREATE_LINKED_PRODUCT_BEGIN");
    try {
      const response = await products.createLinkedProduct(lead_id, payload);
      commit("CREATE_LINKED_PRODUCT_SUCCESSFUL", response.data);
    } catch(err) {
      dispatch("alerts/setAlert", { type: "error", message: err.response.data.message }, { root: true });
      commit("CREATE_LINKED_PRODUCT_ERROR", err.response.data);
    }
  },
};

const getters = {
  getLinkedProducts: state => state.linkedProduct,
  getLinkedProductId: state => leadID => {
    return state.linkedProduct.reduce((acc, obj) => {
      if(obj.product_1_id == leadID) { acc.lead = obj.product_2_id }
      if(obj.product_2_id == leadID) { acc.lead = obj.product_1_id }
      return acc;
    }, { lead: null });
  },
  getLinkedProductByType: state => type => {
    const link = state.linkedProduct.filter(product => product.link_type === type);
    return link.length ? link[link.length - 1] : {};
  },

  getIsFetchLinkedProductLoading: state => state.isFetchLinkedProductLoading,
  getIsFetchLinkedProductError: state => state.isFetchLinkedProductError,
  getIsFetchLinkedProductErrorResponse: state => state.isFetchLinkedProductErrorResponse,

  getIsCreateLinkedProductLoading: state => state.isCreateLinkedProductLoading,
  getIsCreateLinkedProductError: state => state.isCreateLinkedProductError,
  getIsCreateLinkedProductErrorResponse: state => state.isCreateLinkedProductErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  